import {
  COOKIE_KEY_FOR_SERVER_SIDE_SUBSCRIPTION_CHECK,
  ENCODED_COOKIE_VALUES_FOR_SERVER_SIDE_SUBSCRIPTION_CHECK,
} from 'constants/ai'
import { NextPageContext } from 'next'

import { getServerCookie } from './get-server-cookie'
/**
 * Server-side function to read user subscription cookie
 * Decodes the stored values to determine user status. This should only be called on the server side.
 * @param ctx - The context of the server
 * @returns Whether the user is a subscriber
 */
export const getSubscriptionStatusFromCookie = (ctx?: NextPageContext): boolean => {
  if (typeof window !== 'undefined') {
    console.warn('getSubscriptionStatusFromCookie should only be called on the server side')
    return false
  }

  const cookieValue = getServerCookie(ctx, COOKIE_KEY_FOR_SERVER_SIDE_SUBSCRIPTION_CHECK)
  return cookieValue === ENCODED_COOKIE_VALUES_FOR_SERVER_SIDE_SUBSCRIPTION_CHECK.ACTIVE
}
